import React from 'react';
import ReadyProvider from '@/providers/ReadyProvider';
import QueryProvider from '@/providers/QueryProvider';
import IntlProvider from '@/providers/IntlProvider';
import NiceModal from '@ebay/nice-modal-react';
import { ErrorBoundary } from '@hyper-origin/error-handling';

function AppProvider({ children }) {
  return (
    <IntlProvider>
      <ReadyProvider>
        <ErrorBoundary>
          <QueryProvider>
            <NiceModal.Provider>
              {children}
            </NiceModal.Provider>
          </QueryProvider>
        </ErrorBoundary>
      </ReadyProvider>
    </IntlProvider>
  );
}

export default AppProvider;
